<div
  #host
  class="dsg-screen-preview"
  [attr.data-design-screen]="screen().id"
  [class.is-fit-width]="isFitWidth()"
  [class.is-native]="isNative()"
  [style.background-color]="screen().background"
>
  <div class="dsg-screen-scroller" [ngStyle]="scrollerStyles()">
    <section
      #stage
      class="dsg-screen-stage"
      [ngStyle]="stageStyles()"
      [attr.aria-label]="screen().name + ' preview'"
    >
      <app-design-node-view
        *ngFor="let node of nodes(); trackBy: trackNode"
        [node]="node"
        [inFlow]="childrenInFlow()"
        [siblings]="nodes()"
        [interactive]="isFitWidth() || isNative()"
        (iconAction)="runIcon($event)"
        (iconFileDrop)="dropIconFile($event)"
      ></app-design-node-view>
    </section>
  </div>

  <section *ngIf="isFitWidth() && actions.panel() && actions.panel() !== 'info'" class="dsg-action-panel" role="dialog" aria-label="Dashboard filters">
    <header><strong>{{ actions.panel() === 'search' ? 'Search filter options' : 'Dashboard filters' }}</strong>
      <button type="button" (click)="actions.panel.set(null)" aria-label="Close filters">×</button></header>
    <input type="search" autofocus placeholder="Search options" aria-label="Search filter options"
      [ngModel]="filterQuery()" (ngModelChange)="filterQuery.set($event)" />
    <p *ngIf="!filterTiles().length">Add and connect a dropdown filter to this screen to filter dashboard data.</p>
    <label *ngFor="let tile of filterTiles()">
      <span>{{ tile.title || tile.dropdownControl!.field }}</span>
      <select [ngModel]="tile.dropdownControl!.value[0] || ''" (ngModelChange)="changeFilter(tile.id, $event)">
        <option value="">All</option>
        <option *ngFor="let option of filterOptions(tile.dropdownControl!.options)" [value]="option">{{ option }}</option>
      </select>
    </label>
    <button type="button" (click)="actions.runtime?.refreshDashboard(true)">Reset filters</button>
  </section>
  <section *ngIf="isFitWidth() && actions.panel() === 'info'" class="dsg-action-panel" role="dialog" [attr.aria-label]="actions.infoTitle()">
    <header><strong>{{ actions.infoTitle() }}</strong>
      <button type="button" (click)="actions.panel.set(null)" aria-label="Close information">×</button></header>
    <p *ngIf="actions.infoLoading()" role="status">Loading information…</p>
    <p *ngIf="actions.infoError()" role="alert">{{ actions.infoError() }}</p>
    <div class="dsg-info-text" *ngIf="!actions.infoLoading() && !actions.infoError()">{{ actions.infoText() }}</div>
  </section>
  <div *ngIf="isFitWidth() && actions.message()" class="dsg-action-feedback" role="status">
    {{ actions.message() }} <button type="button" (click)="actions.message.set('')" aria-label="Dismiss message">×</button>
  </div>
  <div *ngIf="isFitWidth() && actions.runtime?.dashboardError()" class="dsg-action-feedback" role="alert">
    {{ actions.runtime?.dashboardError() }}
    <button type="button" (click)="dismissDashboardError()" aria-label="Dismiss error">×</button>
  </div>

</div>
